import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'

type ICheckCurrentPasswordModalActionsProps = {
  store: ProfileStore
  field: string
}

export const CheckCurrentPasswordModalActions = observer(
  ({ store, field }: ICheckCurrentPasswordModalActionsProps) => {
    const { loading, currentPassword, handleCheckPasswordNext, onCloseModal } = store

    return (
      <>
        <Button
          text='Cancel'
          onClick={onCloseModal}
          typeBtn={'contained'}
          size={'medium'}
          contained={'secondary'}
        />
        <Button
          text='Next'
          onClick={() => handleCheckPasswordNext(field)}
          disabled={loading || !currentPassword.trim()}
          loading={loading}
        />
      </>
    )
  }
)
